//src/utils/logger.js

const isDev = process.env.NODE_ENV !== "production";
const isDebug = process.env.REACT_APP_DEBUG === "true";

/**
 * Dev-only trace log. Eliminated from production builds by terser.
 */
export const devLog = (...args) => {
  if (isDev || isDebug) console.log(...args);
};

/**
 * Dev-only warning. Eliminated from production builds by terser.
 */
export const devWarn = (...args) => {
  if (isDev || isDebug) console.warn(...args);
};

/**
 * Error logger. Shows console.error in dev for stack traces.
 * No-op in production until error monitoring is wired in.
 * Sentry/Datadog will be added in the future.
 */
export const logError = (...args) => {
  if (isDev || isDebug) {
    console.error(...args);
  }
  // TODO: wire error monitoring for production
};
